import { render } from "./AppAcademics.vue?vue&type=template&id=d0d2a212"
import script from "./AppAcademics.vue?vue&type=script&lang=js"
export * from "./AppAcademics.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__